import React from "react";
import { AppLayout, Button, Flashbar, Form, FormField, Input, Select } from "@amzn/awsui-components-react";
import { Redirect } from "react-router-dom";

import SideBar from "../../navigation/sidebar.js";

import { verify, getOptions, getApiUrl } from "../../auth/login.js";
import { configs } from "../test-data.js";

import "./create.css";

class SandboxConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: props.selected,
            configs: configs,
            sandboxId: "",
            type: "ml.t2.medium",
            size: 20,
            idleThreshold: 5,
            idleTime: 30,
        };

        this.create = this.create.bind(this);
    }

    create() {
        const newConfig = {
            sandboxId: this.state.sandboxId,
            sandboxStatus: "Unknown",
            sandboxProperties: {
                diskSizeInGB: this.state.size,
                sandboxInstanceType: this.state.type,
            },
            sandboxLifeCycleConfig: {
                idleTimeToStopInMin: this.state.idleTime,
                idleCPUThreshold: this.state.idleThreshold,
            },
        };
        this.props.setLoading();
        this.props.createSandbox(newConfig);
    }

    render() {
        if (!localStorage.getItem("account")) {
            return <Redirect to={"/"} />;
        }

        return (
            <div className="awsui-util-container col-l-8 col-xl-7 col-m-9 col-s-12 col-xs-12 col-xxs-12">
                <div className="awsui-util-container-header">
                    <h2>Change Configuration</h2>
                </div>
                <div>
                    <div className="sandbox-form-text">
                        <FormField label="Instance Name" description="Provide the name of your instance..">
                            <Input
                                type="text"
                                onChange={({ detail }) => {
                                    this.setState({ sandboxId: detail.value });
                                }}
                                value={this.state.sandboxId}
                                placeholder="Pick a name"
                            />
                        </FormField>
                    </div>
                    <FormField label="Instance Type" description="Provide the type of your instance..">
                        <Select
                            selectedLabel="Selected"
                            options={configs.types}
                            selectedOption={{ id: this.state.type, label: this.state.type }}
                            empty="No options"
                            placeholder="Choose a type"
                            className="awsui-util-mb-xl"
                            ariaRequired={true}
                            onChange={({ detail }) => {
                                this.setState({ type: detail.selectedOption.id });
                            }}
                        />
                    </FormField>

                    <div className="sandbox-form-text">
                        <FormField label="Storage Size" description="Indicate the storage size of your instance in GB.">
                            <Input
                                type="number"
                                onChange={({ detail }) => {
                                    if (detail.value > 0 && detail.value < 100) {
                                        this.setState({ size: parseInt(detail.value, 10) });
                                    } else if (detail.value < 1) {
                                        this.setState({ size: 1 });
                                    } else {
                                        this.setState({ size: 99 });
                                    }
                                }}
                                value={this.state.size.toString()}
                            />
                        </FormField>
                    </div>
                    <div className="sandbox-form-text">
                        <FormField
                            label="Instance Uptime"
                            description="Provide how long your instance can be idle before automatically stopping in minutes."
                        >
                            <Input
                                type="number"
                                onChange={({ detail }) => {
                                    if (detail.value > 0 && detail.value < 100) {
                                        this.setState({ idleTime: parseInt(detail.value, 10) });
                                    } else if (detail.value < 1) {
                                        this.setState({ idleTime: 1 });
                                    } else {
                                        this.setState({ idleTime: 99 });
                                    }
                                }}
                                value={this.state.idleTime.toString()}
                            />
                        </FormField>
                    </div>
                    <div className="sandbox-form-text">
                        <FormField
                            label="Idle Threshold"
                            description="Designate the CPU usage threshold for this sandbox to be considered idle in minutes."
                        >
                            <Input
                                onChange={({ detail }) => {
                                    if (detail.value > 0 && detail.value <= 10) {
                                        this.setState({ idleThreshold: parseInt(detail.value, 10) });
                                    } else if (detail.value < 1) {
                                        this.setState({ idleThreshold: 1 });
                                    } else {
                                        this.setState({ idleThreshold: 10 });
                                    }
                                }}
                                value={this.state.idleThreshold.toString()}
                                type="number"
                            />
                        </FormField>
                    </div>
                    <div className="awsui-grid">
                        <div className="awsui-row">
                            <Button
                                id="update-button"
                                variant="primary"
                                disabled={this.state.sandboxId.length === 0}
                                loading={this.props.loading}
                                onClick={this.create}
                            >
                                Create
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class CreateForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showAlert: false,
            alert: "",
            showSuccess: false,
            success: "",
        };

        this.createSandbox = this.createSandbox.bind(this);
        this.showAlert = this.showAlert.bind(this);
        this.showSuccess = this.showSuccess.bind(this);
        this.setLoading = this.setLoading.bind(this);
    }

    componentDidMount() {}

    createSandbox(newConfig) {
        if (newConfig === undefined) {
            this.showAlert("There was an error with the configuration. Please try again with a valid configuration.");
            return;
        } else if (newConfig.sandboxId === undefined) {
            this.showAlert("A valid sandbox was not selected. Please reselect a sandbox to update.");
            return;
        } else if (newConfig.sandboxProperties === undefined) {
            this.showAlert("There was an error with the properties of the sandbox.");
            return;
        } else if (
            newConfig.sandboxProperties.diskSizeInGB === undefined ||
            newConfig.sandboxProperties.diskSizeInGB < 1
        ) {
            this.showAlert("Please select a valid storage size (greater than 0).");
            return;
        } else if (newConfig.sandboxProperties.sandboxInstanceType === undefined) {
            this.showAlert("Please pick a valid instance type.");
            return;
        } else if (newConfig.sandboxLifeCycleConfig === undefined) {
            this.showAlert("There was an error with the configuration. Please try again with a valid configuration.");
            return;
        } else if (
            newConfig.sandboxLifeCycleConfig.idleTimeToStopInMin === undefined ||
            newConfig.sandboxLifeCycleConfig.idleTimeToStopInMin < 1
        ) {
            this.showAlert("Please select a valid idle time (greater than 0).");
            return;
        } else if (
            newConfig.sandboxLifeCycleConfig.idleCPUThreshold === undefined ||
            newConfig.sandboxLifeCycleConfig.idleCPUThreshold < 1
        ) {
            this.showAlert("Please select a valid idle threshold (greater than 0).");
            return;
        }
        verify(async () => {
            const opts = await getOptions();
            opts.method = "POST";
            const user = localStorage.getItem("userId");
            if (user === undefined) {
                this.showAlert(
                    "there was a problem verifying your user alias. Please try again or contact CMLS for support if the issue persists."
                );
            }
            const account = localStorage.getItem("account");
            const body = JSON.stringify({
                awsAccountId: account,
                userAlias: user,
                sandboxInfo: newConfig,
            });
            opts.body = body;
            fetch((await getApiUrl()) + "/create_sandbox", opts)
                .then((res) => {
                    if (res.ok) {
                        this.showSuccess("Your sandbox is being created.");
                    } else {
                        if (res.status === 500) {
                            this.showAlert("There was an error with creating your sandbox. Please try again later.");
                        } else {
                            return res.json();
                        }
                    }
                })
                .then((resBody) => {
                    if (resBody === undefined) {
                        this.setState({ loading: false });
                        return;
                    }
                    if (resBody.message !== undefined && resBody.message !== null) {
                        this.showAlert(resBody.message);
                    } else {
                        this.showAlert("There was an error with creating your sandbox. Please try again later.");
                    }
                    this.setState({ loading: false });
                })
                .catch(this.showAlert);
        });
    }

    showAlert(message) {
        this.setState({
            showAlert: true,
            alert: message,
            showSuccess: false,
            success: "",
        });
    }

    showSuccess(message) {
        this.setState({
            showSuccess: true,
            success: message,
            showAlert: false,
            alert: "",
        });
    }

    setLoading() {
        this.setState({
            loading: true,
        });
    }

    render() {
        if (!localStorage.getItem("account")) {
            return <Redirect to={"/"} />;
        }

        return (
            <div>
                {this.state.showAlert || this.state.showSuccess ? (
                    <div id="flashbar">
                        <Flashbar
                            items={[
                                {
                                    type: this.state.showAlert ? "error" : "success",
                                    content: this.state.showAlert ? this.state.alert : this.state.success,
                                    dismissible: true,
                                    onDismiss: () =>
                                        this.setState({
                                            showAlert: false,
                                            alert: "",
                                            showSuccess: false,
                                            success: "",
                                        }),
                                },
                            ]}
                        />
                    </div>
                ) : null}

                <Form>
                    <SandboxConfig
                        loading={this.state.loading}
                        setLoading={this.setLoading}
                        createSandbox={this.createSandbox}
                    />
                </Form>
            </div>
        );
    }
}

const Content = () => (
    <div id="Create">
        <h1>Create Sandbox</h1>
        <CreateForm />
    </div>
);

function Create() {
    return (
        <AppLayout
            content={<Content />}
            navigation={<SideBar activeHref="/create" />}
            navigationOpen={true}
            toolsHide={true}
        />
    );
}

export default Create;
